import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClassificationDto } from '@models/competition/dtos/classification/classification-dto';

@Component({
  selector: 'sigecom-new-modal-classification',
  templateUrl: './new-modal.component.html'
})
export class NewModalClassificationComponent {
  @Input() show = false;
  @Output() showChange = new EventEmitter<boolean>();
  @Input() dados?: ClassificationDto;

  // aqui deve ser o tipo do participante para a classificacao e devemos chamar esse item no html para colocar as informacoes
  @Input() item: any;

  close() {
    this.show = false;
    this.showChange.emit(this.show);
  }
}
